import React, { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const GameTeaching = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();
  const i18n = (key) => t(`gameTeaching.${key}`);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <section className="w-full mt-[10px] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark mb-[15px]">
      <h1 className="text-center my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("Game teaching")}
      </h1>
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          <Accordion>
            <Accordion.Title
              active={activeIndex === 0}
              index={0}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("How to play online slot machines")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("Find discounts in online casinos")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Look for casinos")}
              </div>
            </Accordion.Content>

            <Accordion.Title
              active={activeIndex === 1}
              index={1}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n(
                  "Online slot betting strategy-how to make money when you are interested"
                )}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 1} className="!pl-6">
              <div className="mb-6 flex flex-col">{i18n("Let me tell")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("The reason why online slot machines are so popular")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Online slot machines")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Low investment and high return")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("This is what")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("You can play with change")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("This is true")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("Constantly producing new types of games")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("During the centuries")}
              </div>
            </Accordion.Content>

            <Accordion.Title
              active={activeIndex === 2}
              index={2}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("Popular e-sports")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 2} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("With the increasing")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("E-sports has been")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("Event type:")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("1. League of Legends")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("Also known as")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("Counter-Strike: Global Offensive")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Usually referred")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("How to bet:")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("E-sports betting")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("Handicap")}</div>
              <div className="mb-6 flex flex-col">{i18n("Referred to as")}</div>
              <div className="mb-6 flex flex-col">{i18n("Than size")}</div>
              <div className="mb-6 flex flex-col">{i18n("Abbreviated as")}</div>
              <div className="mb-6 flex flex-col">{i18n("Win or lose")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("Win-loss betting")}
              </div>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 3}
              index={3}
              onClick={handleClick}
              className="flex items-center"
            >
              <Icon name="dropdown" />
              <h1 className="!my-2 text-base-light-dark dark:text-base-light-white text-xl font-semibold">
                {i18n("Baccarat entry rules")}
              </h1>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 3} className="!pl-6">
              <div className="mb-6 flex flex-col">
                {i18n("Baccarat is simply a game of betting on the bank.")}
              </div>

              <div className="mb-6 flex flex-col">
                {i18n("There is no strict")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("In addition to the")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Point calculation")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Look for casinos")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("When any one gets")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("In other situations")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n(
                  "Bank pair or player pair is limited to the first two cards, not counting the third out card."
                )}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Standard Baccarat")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n(
                  "If you bet on the banker and the banker wins, you win 1 and lose 1, and another 5% commission will be deducted to the banker."
                )}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n(
                  "Bet on the player and the idle winner, win 1 and lose 1."
                )}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n(
                  "A bet on a tie (that is, the one with the same final points), win 1 and pay 8."
                )}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n(
                  "A bet on a pair (that is, the first two cards of the banker or player are the same numbers or letters), win 1 and pay 11"
                )}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("In the event of")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Water-free baccarat")}
              </div>
              <div className="mb-6 flex flex-col">{i18n("The odds for")}</div>
              <div className="mb-6 flex flex-col">
                {i18n("The banker beats")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Betting on Super6")}
              </div>
              <div className="mb-6 flex flex-col">
                {i18n("Western Baccarat")}
              </div>
            </Accordion.Content>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default GameTeaching;
